/**
 * Register Microservices Here.
 *
 * environment.httpApiServiceNameUrlMap URLs will be added automatically
 */
const microservices = {
    // serviceName : 'name-in-URL'
    arApp: 'ar-app-api',
    fundingApi: 'fund-funding-api',
    reportCenter: 'report-center',
    financingGql: 'financing-graphql',
    invoiceApi: 'inv-restapi',
    paymentsApi: 'pmt-restapi',
    legalEntityApi: 'le-ref-restapi'
};

/**
 * Register Microfrontend Here
 *
 * mfeRemoteNameUrlMap URLs will be added automatically
 */
const microfrontends = {
    // mfeName : [ 'name-in-URL', portForLocalDevelopment ]
    arApp: ['ar-app', 4202]
};

export type EnvKey = 'prod' | 'staging' | 'dev' | 'demo' | 'staging-demo' | 'uat';

const microserviceUrl = (env: EnvKey, name) =>
    `https://${env}.${env === 'prod' ? 'lsq' : 'lsqlabs'}.com/${name}`;

const microfrontendUrl = (env: EnvKey, [name, port]) =>
    (env === 'dev' && isLocalHost
        ? `http://localhost:${port}`
        : env === 'prod'
        ? `https://${name}.lsq.com`
        : env === 'dev'
        ? `https://${name}.development.lsqlabs.com`
        : `https://${name}.${env}.lsqlabs.com`) + '/remoteEntry.mjs';

export const microservicesAtEnv = mapObject(microservices, microserviceUrl);
export const microfrontendsAtEnv = mapObject(microfrontends, microfrontendUrl);

type ServiceUrls<T> = (env: EnvKey) => {
    [key in keyof T]: string;
};

function mapObject<S>(obj: S, map): ServiceUrls<S> {
    return (env: EnvKey) =>
        Object.keys(obj).reduce((result, key) => {
            result[key] = map(env, obj[key]);
            return result;
        }, {}) as any;
}

const isLocalHost = window.location.hostname === 'localhost';
